import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Alert, Button, Typography, Form } from 'components/base';

const CheckoutShippingAddressValidatorModal = props => {
  const shippingAddresses = [];
  const [selectedAddressIndex, setSelectedAddressIndex] = useState(0);

  if (props.suggestedAddress) {
    shippingAddresses.push({ index: 0, ...props.suggestedAddress });
  }
  shippingAddresses.push({ index: 1, ...props.address });

  const handleOnConfirm = async (e, addressIndex) => {
    const { index, ...address } = shippingAddresses[addressIndex];
    await props.onSuccess(address);
    props.close(e);
  };

  if (props.suggestedAddress) {
    return (
      <>
        <Typography.P>
          To ensure accurate delivery, please consider the changes highlighted below.
        </Typography.P>
        {props.suggestedAddress.residential === false && (
          <Alert type="warning" className="mb-2">
            This address appears to be a PO Box or non-residential location. Delivery to these
            addresses may fail.
          </Alert>
        )}
        <div className="form-group-set mb-2">
          {shippingAddresses.map(address => (
            <ShippingAddressItem
              key={address.index}
              index={address.index}
              address={address}
              active={address.index === selectedAddressIndex}
              recommended={address.index === 0}
              onSelect={setSelectedAddressIndex}
            />
          ))}
        </div>
        <Button type="primary" block onClick={e => handleOnConfirm(e, selectedAddressIndex)}>
          Confirm
        </Button>
      </>
    );
  }

  return (
    <>
      <Typography.P>
        To ensure accurate delivery, please consider updating your address.
      </Typography.P>
      <div className="form-group-set mb-2">
        <ShippingAddressItem
          index={0}
          address={props.address}
          active
          onSelect={setSelectedAddressIndex}
        />
      </div>
      <Button type="primary" block onClick={e => handleOnConfirm(e, 0)}>
        Use This Anyway
      </Button>
      <Button transparent block onClick={props.close}>
        Update Address
      </Button>
    </>
  );
};

CheckoutShippingAddressValidatorModal.propTypes = {
  address: PropTypes.object,
  suggestedAddress: PropTypes.object,
  onSuccess: PropTypes.func,
  close: PropTypes.func,
};

const ShippingAddressItem = props => {
  const className = classNames({
    'form-check': true,
    'form-check-card': true,
    active: props.active,
  });

  const handleOnChange = () => {
    props.onSelect(props.index);
  };

  const { address } = props;

  const title = `${address.name}, ${address.street}${address.street2 ? `, ${address.street2}` : ''
    }`;
  const description = `${address.city}, ${address.zip}${address.state ? `, ${address.state}` : ''
    }, ${address.country_code}`;

  return (
    <Form.Group className="mb-0">
      <div className={className}>
        <input
          type="radio"
          id={`shippingAddress${props.index}`}
          checked={props.active}
          name="shippingAddress"
          className="form-check-input"
          value={props.index}
          onChange={handleOnChange}
        />
        <label className="label form-check-label" htmlFor={`shippingAddress${props.index}`}>
          <strong className="d-block text-black">{title}</strong>
          {description}
          <br />
          {props.recommended && <strong>(Suggested address)</strong>}
          {!props.recommended && <span>(What you entered)</span>}
        </label>
      </div>
    </Form.Group>
  );
};

ShippingAddressItem.propTypes = {
  index: PropTypes.number,
  address: PropTypes.object,
  active: PropTypes.bool,
  recommended: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default CheckoutShippingAddressValidatorModal;
